import styled from 'styled-components'
import Icon from '@mdi/react'
import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const StyledAccountMenuWrapper = styled.div`
  display: none;
  position: relative;
  margin-left: ${theme.spacing.base};

  @media ${theme.devices.desktop} {
    display: block;
  }
`
export const StyledAccountMenuBtn = styled.button<{ isMenuOpen: boolean }>`
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 ${theme.spacing.s};
  height: 44px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(p) =>
    p.isMenuOpen ? `${theme.overlay.newDropdownBlack}` : 'transparent'};
  backdrop-filter: ${(p) => (p.isMenuOpen ? `${theme.overlay.SBlur}` : 'none')};

  :hover {
    background-color: ${theme.overlay.newDropdownBlack};
    backdrop-filter: ${theme.overlay.SBlur};
  }
`

export const StyledDomainName = styled.div`
  color: ${theme.colors.lightGrey};
  font-weight: 600;
  margin: 0 16px;
`

export const StyledArrowIcon = styled(Icon)`
  color: ${theme.colors.lightGrey};
  transition: transform 0.2s ease;
`

export const StyleHeaderMenuSubTitle = styled.div`
  ${Font14}
  padding: ${theme.spacing.s};
  color: ${theme.colors.darkeyGrey};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: ${theme.colors.grey};

  @media ${theme.devices.desktop} {
    padding-bottom: 0;
    background-color: transparent;
  }
`
